import "./index.scss";
import {
  ConfigProvider,
  Segmented,
  Button,
  Form,
  Table,
  message,
  Upload,
  Col,
  Row,
  Space,
  DatePicker,
  Spin,
  Divider,
  Pagination,
  Modal,
  Tabs,
} from "antd";
import zh_TW from "antd/locale/zh_TW";
import "dayjs/locale/zh-tw";

import { useEffect, useRef, useState, useMemo } from "react";
import { BASE_URL } from "../../api/config";
import request from "../../api/request";
import axios from "axios";
import ReactECharts from "echarts-for-react";
import DataChart from '../../components/DataChart';
import dayjs from "dayjs";
import { DownloadOutlined } from "@ant-design/icons";

const Analyse = () => {
  const [alignValue, setAlignValue] = useState("center");

  const onFinish = (values) => {
    // console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
  };
  const [month, setMonth] = useState("");
  const mon = useRef(0);
  const uploadRef1 = useRef(null);
  const onDatePickerChange = (date, dateString) => {
    // console.log('onDatePickerChange', date, dateString, typeof dateString);
    //javascript 将 - 替换成 ''
    // console.log("dateString",dateString)
    setMonth(dateString.replace(/-/g, ""));
    mon.current = dateString.replace(/-/g, "");
    setUploadingStatus1(0);
    setFileList1([]);
    setUploadingStatus2(0);
    setMessage1("");
    setMessage2("");
    setMessage3("");
    setMessage4("");
    setFileList2([]);
    setUploadingStatus3(0);
    setFileList3([]);
    setUploadingStatus4(0);
    setFileList4([]);
    getFileList();
    // setFileList1([
    //     {
    //         uid: '3',
    //         name: 'zzz.png',
    //         status: 'error',
    //         response: 'Server Error 500', // custom error message to show
    //         url: 'http://www.baidu.com/zzz.png',
    //     },
    // ])
    if (dateString) {
      getXls();
    }
  };
  const getXls = () => {
    setSpinning(true);
    request
      .post(BASE_URL + "/file/get_inputs?report_month=" + mon.current, {})
      .then((res) => {
        setSpinning(false);
        if (res.code === 200 && res.data && res.data.length) {
          res.data.forEach((item) => {
            if (item.indexOf("進流水質報表") > -1) {
              setFileList1([
                {
                  uid: "3",
                  name: "進流水質報表.xls",
                  response: {
                    code: 200,
                    data: {
                      path: item,
                    },
                  },
                  status: "done", // custom error message to show
                },
              ]);
              setMessage1("進流水質報表.xls");
            } else if (item.indexOf("進流時水量水質報表") > -1) {
              setFileList2([
                {
                  uid: "3",
                  name: "進流時水量水質報表.xls",
                  response: {
                    code: 200,
                    data: {
                      path: item,
                    },
                  },
                  status: "done", // custom error message to show
                },
              ]);
              setMessage2("進流時水量水質報表.xls");
            } else if (item.indexOf("前處理水質報表") > -1) {
              setFileList3([
                {
                  uid: "3",
                  name: "前處理水質報表.xls",
                  response: {
                    code: 200,
                    data: {
                      path: item,
                    },
                  },
                  status: "done", // custom error message to show
                },
              ]);
              setMessage3("前處理水質報表.xls");
            } else if (item.indexOf("Biowin MBR 報表") > -1) {
              setFileList4([
                {
                  uid: "3",
                  name: "Biowin MBR 報表.xls",
                  response: {
                    code: 200,
                    data: {
                      path: item,
                    },
                  },
                  status: "done", // custom error message to show
                },
              ]);
              setMessage4("Biowin MBR 報表.xls");
            }
          });
        }
      })
      .catch((err) => {
        setSpinning(false);
      });
  };

  //狀態 按鈕文字  0 選擇檔案   1上傳中(按鈕不操作 吐司彈窗)  2上傳成功 重新上傳
  //狀態 按鈕顏色  0 選擇檔案(綠色)   上傳成功 紅色
  const [spinning, setSpinning] = useState(false);

  const [uploadingStatus1, setUploadingStatus1] = useState(0);

  const [fileList1, setFileList1] = useState([]);
  const [message1, setMessage1] = useState("");
  const [fileList2, setFileList2] = useState([]);
  const [message2, setMessage2] = useState("");
  const [fileList3, setFileList3] = useState([]);
  const [message3, setMessage3] = useState("");
  const [fileList4, setFileList4] = useState([]);
  const [message4, setMessage4] = useState("");

  useEffect(() => {
    if (fileList1[0]) {
      const res = fileList1[0].response;
      if (res && res.code === 200) {
        setUploadingStatus1(2);
        setSpinning(false);
        setMessage1("進流水質報表.xls");
      } else if (res && res.code !== 200) {
        setUploadingStatus1(0);
        setFileList1([]);
        setSpinning(false);
        let message = "上傳失敗";
        try {
          const messageInfo = JSON.parse(res.message);
          message = messageInfo.message;
        } catch (e) {}
        setMessage1(message);
      }
    }
  }, [fileList1]);

  useEffect(() => {
    if (fileList2[0]) {
      const res = fileList2[0].response;
      if (res && res.code === 200) {
        setUploadingStatus2(2);
        setSpinning(false);
        setMessage2("進流時水量水質報表.xls");
      } else if (res && res.code !== 200) {
        setUploadingStatus2(0);
        setFileList2([]);
        setSpinning(false);
        let message = "上傳失敗";
        try {
          const messageInfo = JSON.parse(res.message);
          message = messageInfo.message;
        } catch (e) {}
        setMessage2(message);
      }
    }
  }, [fileList2]);

  useEffect(() => {
    if (fileList3[0]) {
      const res = fileList3[0].response;
      if (res && res.code === 200) {
        setUploadingStatus3(2);
        setSpinning(false);
        setMessage3("前處理水質報表.xls");
      } else if (res && res.code !== 200) {
        setUploadingStatus3(0);
        setFileList3([]);
        setSpinning(false);
        let message = "上傳失敗";
        try {
          const messageInfo = JSON.parse(res.message);
          message = messageInfo.message;
        } catch (e) {}
        setMessage3(message);
      }
    }
  }, [fileList3]);

  useEffect(() => {
    if (fileList4[0]) {
      const res = fileList4[0].response;
      if (res && res.code === 200) {
        setUploadingStatus4(2);
        setSpinning(false);
        setMessage4("Biowin MBR 報表.csv");
      } else if (res && res.code !== 200) {
        setUploadingStatus4(0);
        setFileList4([]);
        setSpinning(false);
        let message = "上傳失敗";
        try {
          const messageInfo = JSON.parse(res.message);
          message = messageInfo.message;
        } catch (e) {}
        setMessage4(message);
      }
    }
  }, [fileList4]);

  // const uploadingStatus1 =  useRef(0)
  const uploadProps1 = {
    name: "file",
    action: BASE_URL + `/file/upload?type=1&report_month=${month}`,
    headers: {
      authorization: "authorization-text",
    },
    timeout: 5000,
    beforeUpload: (file) => {
      if (!month) {
        message.error("請先選擇月份");
        return Upload.LIST_IGNORE;
      }
      return validateFileType(file, ".xls,.xlsx");
    },
    onChange(info) {
      setSpinning(true);
      setLoadingText('上傳中');
      setMessage1("");
      setFileList1([...info.fileList]);
      if (info.file.status === "uploading") {
        // setSpinning(true)
      }
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
        // setSpinning(false)
      }

      if (info.file.status === "done") {
        setUploadingStatus1(2);
        setSpinning(false);
        // uploadingStatus1.current = 2;
      } else if (info.file.status === "error") {
        setUploadingStatus1(0);
        setSpinning(false);
        // uploadingStatus1.current = 0;
        // message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const [uploadingStatus2, setUploadingStatus2] = useState(0);
  const uploadProps2 = {
    name: "file",
    action: BASE_URL + `/file/upload?type=2&report_month=${month}`,
    headers: {
      authorization: "authorization-text",
    },
    beforeUpload: (file) => {
      if (!month) {
        message.error("請先選擇月份");
        return Upload.LIST_IGNORE;
      }
      return validateFileType(file, ".xls,.xlsx");
    },
    onChange(info) {
      setSpinning(true);
      setLoadingText('上傳中');
      setFileList2([...info.fileList]);
      if (info.file.status === "uploading") {
        setSpinning(true);
      }
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
        setSpinning(false);
      }
      if (info.file.status === "done") {
        setUploadingStatus2(2);
      } else if (info.file.status === "error") {
        setUploadingStatus2(0);
        // message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const [uploadingStatus3, setUploadingStatus3] = useState(0);
  const uploadProps3 = {
    name: "file",
    action: BASE_URL + `/file/upload?type=3&report_month=${month}`,
    headers: {
      authorization: "authorization-text",
    },
    beforeUpload: (file) => {
      if (!month) {
        message.error("請先選擇月份");
        return Upload.LIST_IGNORE;
      }
      return validateFileType(file, ".xls,.xlsx");
    },
    onChange(info) {
      setSpinning(true);
      setLoadingText('上傳中');
      setFileList3([...info.fileList]);
      if (info.file.status === "uploading") {
        setSpinning(true);
      }
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
        setSpinning(false);
      }
      if (info.file.status === "done") {
        setUploadingStatus3(2);
      } else if (info.file.status === "error") {
        setUploadingStatus3(0);
        // message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const [uploadingStatus4, setUploadingStatus4] = useState(0);
  const uploadProps4 = {
    name: "file",
    action: BASE_URL + `/file/upload?type=4&report_month=${month}`,
    headers: {
      authorization: "authorization-text",
    },
    beforeUpload: (file) => {
      if (!month) {
        message.error("請先選擇月份");
        return Upload.LIST_IGNORE;
      }
      return validateFileType(file, ".csv");
    },
    onChange(info) {
      setSpinning(true);
      setLoadingText('上傳中');
      setFileList4([...info.fileList]);
      if (info.file.status === "uploading") {
        setSpinning(true);
      }
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
        setSpinning(false);
      }
      if (info.file.status === "done") {
        setUploadingStatus4(2);
      } else if (info.file.status === "error") {
        setUploadingStatus4(0);
      }
    },
  };

  const dataSource = [
    {
      key: "1",
      date: "2024-10-18",
      time: "2024-09-10 14:00:00",
      result: "AI模型預測結果",
    },
    {
      key: "2",
      date: "2024-10-18",
      time: "2024-09-10 15:00:00",
      result: "AI模型預測結果",
    },
    {
      key: "3",
      date: "2024-10-18",
      time: "2024-09-10 16:00:00",
      result: "AI模型預測結果",
    },
  ];

  const columns = [
    {
      title: "預測時間",
      dataIndex: "report_month",
      key: "report_month",
      align: "center",
    },
    {
      title: "操作時間",
      dataIndex: "create_time",
      key: "create_time",
      align: "center",
    },
    {
      title: "操作結果",
      dataIndex: "result",
      key: "result",
      align: "center",
      render: (result, record) => {
        //使用render的时候要进行return
        if (result === "success") {
          return (record.type === 1 ? "AI模型預測" : "混合模型預測") + "成功";
        } else if (result === "error") {
          return (record.type === 1 ? "AI模型預測" : "混合模型預測") + "失敗";
        }
      },
    },
    {
      title: "預測結果",
      dataIndex: "",
      align: "center",
      key: "x",
      render: (text, record) =>
        // record.result === 'success' ? (
        //     <span onClick={downLoad(record)} style={{color: '#4CAF50'}}>下載</span>
        // ) : ''
        record.result === "success" ? (
          <span>
            <Button size="small" type="link" onClick={() => downLoad(record)}>
              查看結果
            </Button>
          </span>
        ) : (
          ""
        ),
    },
  ];

  const [modalTitle, setModalTitle] = useState('');

  const [currentRecord, setCurrentRecord] = useState(null);

  const downLoad = async (record) => {
    setSpinning(true);
    try {
      const response = await axios({
        url: BASE_URL + `/file/download?id=${record.id}`,
        method: "POST",
        responseType: "blob",
      });

      const text = await response.data.text();
      
      // 解析 CSV 數據
      const rows = text.split('\n')
        .filter(line => line.trim())
        .map(line => line.split(','));
      
      const headers = rows[0];
      const data = rows.slice(1);
      
      // 按日期整理數據，但保留完整時間戳
      const dailyData = data.reduce((acc, row) => {
        const datetime = row[0];  // 保留完整的時間戳
        const day = datetime.split(' ')[0].split('-')[2];
        
        if (!acc[day]) {
          acc[day] = {
            pH: [],
            SS: [],
            COD: [],
            timestamps: []  // 新增時間戳數組
          };
        }
        acc[day].pH.push(parseFloat(row[1]));
        acc[day].SS.push(parseFloat(row[2]));
        acc[day].COD.push(parseFloat(row[3]));
        acc[day].timestamps.push(datetime);  // 保存完整時間戳
        return acc;
      }, {});

      const days = Object.keys(dailyData).sort((a, b) => parseInt(a) - parseInt(b));
      const processedData = {
        days,
        pH: days.flatMap(day => dailyData[day].pH),
        SS: days.flatMap(day => dailyData[day].SS),
        COD: days.flatMap(day => dailyData[day].COD),
        xLabels: days.flatMap(day => dailyData[day].timestamps)  // 使用完整時間戳
      };
      
      const modelType = record.type === 1 ? 'AI模型' : '混合模型';
      const formattedDate = dayjs(record.report_month).format('YYYY年MM月');
      
      setModalTitle(`${formattedDate} ${modelType}預測結果`);
      setCurrentRecord(record);
      setChartData(null);
      
      await new Promise(resolve => {
        setTimeout(() => {
          setChartData({
            ...processedData,
            _timestamp: Date.now()
          });
          setIsModalVisible(true);
          resolve();
        }, 100);
      });

    } catch (error) {
      console.error("數據讀取失敗：", error);
      message.error("數據讀取失敗");
    } finally {
      setSpinning(false);
    }
  };

  const aiModel = () => {
    if (!month || month === "") {
      message.error("請選擇月份");
    }
    setSpinning(true);
    setLoadingText('預測中');
    request
      .post(BASE_URL + "/file/aiModel", { report_month: mon.current })
      .then((res) => {
        setSpinning(false);
        if (res.code === 200) {
          message.success(res.message);
          getFileList();
        }
      })
      .catch((err) => {
        setSpinning(false);
      });
  };

  const mixModel = () => {
    if (!month || month === "") {
      message.error("請選擇月份");
    }
    setSpinning(true);
    setLoadingText('預測中');
    request
      .post(BASE_URL + "/file/mixModel", { report_month: mon.current })
      .then((res) => {
        setSpinning(false);
        if (res.code === 200) {
          message.success(res.message);
          getFileList();
        }
      })
      .catch((err) => {
        setSpinning(false);
      });
  };
  const [page, setPage] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });

  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const [logList, setLogList] = useState();
  const getFileList = (page2 = null) => {
    let num = page2 ? page2.current : pageNum;
    let limit = page2 ? page2.pageSize : pageSize;
    // page_num=${pagination.current}&page_size=${pagination.pageSize}
    request
      .post(BASE_URL + `/file/get`, {
        page_num: num,
        page_size: limit,
        report_month: mon.current || "",
      })
      .then((res) => {
        if (res.code === 200) {
          setLogList(res.data.rows);
          setPage({
            ...page,
            current: num,
            pageSize: limit,
            total: res.data.total,
          });
        }
      });
  };

  const handleTableChange = (newPagination) => {
    setPageNum(newPagination.current);
    setPageSize(newPagination.pageSize);

    getFileList(newPagination);
    // uploadingStatus1 = 0;
  };

  const downLoadFile1 = () => {
    let path = "";
    if (fileList1.length) {
      path = fileList1[0].response.data.path || "";
      downloadPath(path, 1);
    }
  };

  const downLoadFile2 = () => {
    let path = "";
    if (fileList2.length) {
      path = fileList2[0].response.data.path || "";
      downloadPath(path, 2);
    }
  };

  const downLoadFile3 = () => {
    let path = "";
    if (fileList3.length) {
      path = fileList3[0].response.data.path || "";
      downloadPath(path, 3);
    }
  };

  const downLoadFile4 = () => {    
    let path = "";
    if (fileList4.length) {
      path = fileList4[0].response.data.path || "";
      downloadPath(path, 4);
    }
  };

  const downloadPath = async (path, type) => {
    setSpinning(true);
    try {
      // const {report_month, type} = record
      // const response = await request.post(BASE_URL + `/file/download?report_month=${report_month}&type=${type}`, {}, {
      //     responseType: 'blob'
      // })
      const response = await axios({
        url: BASE_URL + `/file/single_download_file?filename=${path}`, // 替换为实际的下载接口
        method: "POST",
        responseType: "blob", // 设置响应类型为 blob
      });
      setSpinning(false);
      const contentDisposition = response.headers["content-disposition"];
      const objectName = {
        1: "進流水質報表.xls",
        2: "進流時水量水質報表.xls",
        3: "前處理水質報表.xls",
        4: "Biowin MBR 報表.csv",
      };
      let filename = objectName[type]; // 默认文件名
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+)"/);
        if (match && match[1]) {
          filename = match[1];
        }
      }
      // 创建一个 Blob 对象
      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });

      // 创建一个 URL 对象
      const url = window.URL.createObjectURL(blob);

      // 创建一个隐藏的 a 标签
      const link = document.createElement("a");
      link.href = url;
      link.download = filename; // 使用从响应头中获取的文件名
      link.click();
      // 释放 URL 对象
      window.URL.revokeObjectURL(url);
    } catch (error) {
      setSpinning(false);
      console.error("文件下载失败：", error);
    }
  };

  const viewChartData = async (path) => {
    setSpinning(true);
    try {
      const response = await axios({
        url: BASE_URL + `/file/single_download_file?filename=${path}`,
        method: "POST",
        responseType: "blob"
      });

      // 将 blob 转换为文字
      const text = await response.data.text();
      
      // 解析 CSV 数据
      const rows = text.split('\n')
        .filter(line => line.trim())
        .map(line => line.split(','));
      
      const headers = rows[0];
      const data = rows.slice(1);
      
      // 处理数据格式
      const processedData = {
        datetime: data.map(row => row[0]),
        pH: data.map(row => parseFloat(row[1])),
        SS: data.map(row => parseFloat(row[2])),
        COD: data.map(row => parseFloat(row[3]))
      };
      
      setChartData(processedData);
      setIsModalVisible(true);
    } catch (error) {
      console.error("讀取數據失敗：", error);
      message.error("讀取數據失敗");
    } finally {
      setSpinning(false);
    }
  };

  const getChartOption = (title, xData, yData) => {
    return {
      title: {
        text: title,
        textStyle: {
          color: '#fff'
        }
      },
      tooltip: {
        trigger: 'axis'
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: xData,
        axisLabel: {
          color: '#fff',
          rotate: 45
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: '#fff'
        }
      },
      series: [{
        data: yData,
        type: 'line',
        smooth: true
      }]
    };
  };

  useEffect(() => {
    getFileList();
  }, []);

  // 修改文件類型驗證函數
  const validateFileType = (file, acceptTypes) => {
    const fileExtension = file.name.split(".").pop().toLowerCase();
    const types = acceptTypes
      .split(",")
      .map((type) => type.replace(".", "").toLowerCase());

    if (!types.includes(fileExtension)) {
      message.error(`只接受 ${acceptTypes} 格式的文件`);
      return Upload.LIST_IGNORE; // 這會阻止文件上傳
    }
    return true;
  };

  const [loadingText, setLoadingText] = useState('載入中');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [chartData, setChartData] = useState(null);

  // 添加下載 CSV 的函數
  const downloadCSV = async (record) => {
    try {
      const response = await axios({
        url: BASE_URL + `/file/download?id=${record.id}`,
        method: "POST",
        responseType: "blob"
      });

      // 創建 Blob 對象
      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8"
      });

      // 創建下載連結
      const url = window.URL.createObjectURL(blob);
      const modelType = record.type === 1 ? 'AI模型' : '混合模型';
      const formattedDate = dayjs(record.report_month).format('YYYY年MM月');
      const link = document.createElement("a");
      link.href = url;
      link.download = `${formattedDate}${modelType}預測結果.csv`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("下載失敗：", error);
      message.error("下載失敗");
    }
  };

  const [activeTab, setActiveTab] = useState('pH');

  // 在 Modal 中的圖表部分改為：
  const items = useMemo(() => [
    {
      key: 'pH',
      label: 'pH',
      children: (        
        <DataChart
          key={`pH-${activeTab === 'pH' ? chartData?._timestamp : 'inactive'}`}
          title="pH 預測趨勢圖"
          xData={chartData?.xLabels || []}
          yData={chartData?.pH || []}
          yAxisName="pH"
        />
      )
    },
    {
      key: 'SS',
      label: 'SS',
      children: (
        <DataChart
          key={`SS-${activeTab === 'SS' ? chartData?._timestamp : 'inactive'}`}
          title="SS 預測趨勢圖"
          xData={chartData?.xLabels || []}
          yData={chartData?.SS || []}
          yAxisName="SS"
        />
      )
    },
    {
      key: 'COD',
      label: 'COD',
      children: (
        <DataChart
          key={`COD-${activeTab === 'COD' ? chartData?._timestamp : 'inactive'}`}
          title="COD 預測趨勢圖"
          xData={chartData?.xLabels || []}
          yData={chartData?.COD || []}
          yAxisName="COD"
        />
      )
    }
  ], [chartData?._timestamp, activeTab]);

  return (
    <div className="index" style={{ color: "#fff", padding: "20px" }}>
      <Spin 
        spinning={spinning} 
        tip={<div style={{ color: '#fff', marginTop: '35px' }}>{loadingText}</div>}
        percent="auto" 
        fullscreen 
      />
      <div className="analyse-kai" style={{ display: "flex", justifyContent: "center" }}>
        <div className="analyse-box">
          <div className="name">放流水質預測</div>

          <Form
            name="basic"
            labelAlign="left"
            colon={false}
            labelCol={{
              span: 10,
            }}
            wrapperCol={{
              span: 14,
            }}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              labelCol={4}
              label={
                <label style={{ color: "#fff", fontSize: "18px" }}>
                  選擇月份:
                </label>
              }
              name="report1"
            >
              <ConfigProvider locale={zh_TW}>
                <DatePicker
                  size="large"
                  picker="month"
                  onChange={onDatePickerChange}
                  style={{ width: '135px' }}
                />
              </ConfigProvider>
            </Form.Item>
            <Form.Item
              label={
                <label style={{ color: "#fff", fontSize: "18px" }}>
                  進流水質報表（xls/xlsx）
                </label>
              }
              name="report1"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  onClick={downLoadFile1}
                  className={
                    uploadingStatus1 == 2 ? "upload-success" : "upload-danger"
                  }
                >
                  {message1}
                </div>
                <Upload
                  fileList={fileList1}
                  {...uploadProps1}
                  maxCount={1}
                  accept=".xls,.xlsx"
                >
                  <Button
                    color={uploadingStatus1 == 0 ? "success" : "danger"}
                    variant="solid"
                    size="large"
                    disabled={!month}
                  >
                    {uploadingStatus1 == 0 ? "選擇檔案" : "重新上傳"}
                  </Button>
                </Upload>
              </div>
            </Form.Item>

            <Form.Item
              label={
                <label style={{ color: "#fff", fontSize: "18px" }}>
                  進流時水量水質報表（xls/xlsx）
                </label>
              }
              name="report1"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  onClick={downLoadFile2}
                  className={
                    uploadingStatus2 == 2 ? "upload-success" : "upload-danger"
                  }
                >
                  {message2}
                </div>
                <Upload {...uploadProps2} maxCount={1} accept=".xls,.xlsx">
                  <Button
                    color={uploadingStatus2 == 0 ? "success" : "danger"}
                    variant="solid"
                    size="large"
                    disabled={!month}
                  >
                    {uploadingStatus2 == 0 ? "選擇檔案" : "重新上傳"}
                  </Button>
                </Upload>
              </div>
            </Form.Item>

            <Form.Item
              label={
                <label style={{ color: "#fff", fontSize: "18px" }}>
                  前處理水質報表（xls/xlsx）
                </label>
              }
              name="report1"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  onClick={downLoadFile3}
                  className={
                    uploadingStatus3 == 2 ? "upload-success" : "upload-danger"
                  }
                >
                  {message3}
                </div>
                <Upload {...uploadProps3} maxCount={1} accept=".xls,.xlsx">
                  <Button
                    color={uploadingStatus3 == 0 ? "success" : "danger"}
                    variant="solid"
                    size="large"
                    disabled={!month}
                  >
                    {uploadingStatus3 == 0 ? "選擇檔案" : "重新上傳"}
                  </Button>
                </Upload>
              </div>
            </Form.Item>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                onClick={aiModel}
                size="large"
                className="custom-disabled-button"
                disabled={
                  !uploadingStatus1 || !uploadingStatus2 || !uploadingStatus3
                }
              >
                AI模型預測
              </Button>
            </div>

            <Divider style={{ height: "5px", background: "#fff" }} />

            <Form.Item
              label={
                <label style={{ color: "#fff", fontSize: "18px" }}>
                  Biowin MBR 報表（csv）
                </label>
              }
              name="report1"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  onClick={downLoadFile4}
                  className={
                    uploadingStatus4 == 2 ? "upload-success" : "upload-danger"
                  }
                >
                  {message4}
                </div>
                <Upload {...uploadProps4} maxCount={1} accept=".csv">
                  <Button
                    color={uploadingStatus4 == 0 ? "success" : "danger"}
                    variant="solid"
                    size="large"
                    disabled={!month}
                  >
                    {uploadingStatus4 == 0 ? "選擇檔案" : "重新上傳"}
                  </Button>
                </Upload>
              </div>
            </Form.Item>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                onClick={mixModel}
                className="custom-disabled-button"
                disabled={
                  !uploadingStatus1 ||
                  !uploadingStatus2 ||
                  !uploadingStatus3 ||
                  !uploadingStatus4
                }
                size="large"
              >
                混合模型預測
              </Button>
            </div>
          </Form>
          <div className="opt-box">
            <div className="name">操作記錄</div>
            <ConfigProvider
              theme={{
                token: {
                  colorBgContainer: "#002b56",
                  colorText: "#FFF",
                },
                components: {
                  Table: {
                    /* 这里是你的组件 token */
                    headerBg: "#002b56",
                    headerColor: "#FFF",
                    footerColor: "#FFF",
                    footerBg: "#002b56",
                  },
                },
              }}
            >
              <Table
                rowKey="id"
                bordered
                dataSource={logList}
                columns={columns}
                pagination={page}
                onChange={handleTableChange}
              />
            </ConfigProvider>
          </div>
        </div>
      </div>
      <div className="analyse-kaimodal">
        <Modal
          className="analyse-kaimodal"
          title={modalTitle}
          open={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false);
            setModalTitle('');
          }}
          width={1000}
          footer={null}
          destroyOnClose={true}
        >
        <div style={{ padding: '20px' }}>
          <Tabs 
            items={items}
            activeKey={activeTab}
            onChange={setActiveTab}
            destroyInactiveTabPane={true}
            tabBarExtraContent={{
              right: (
                <Button 
                  type="primary" 
                  onClick={() => downloadCSV(currentRecord)}
                  icon={<DownloadOutlined />}
                >
                  下載 CSV
                </Button>
              )
            }}
          />
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Analyse;
